import React from "react";
import { ChatWithUs } from "../images/icons";

const Donate = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-1 md:col-reverse gap-20 items-center py-12 px-24 md:px-6">
      <div className="md:order-last">
        <form action="submit" className="space-y-6">
          <input
            type="text"
            className="w-full h-12 bg-[#979797]/20 px-4 outline-none placeholder:text-secondary"
            name="name"
            placeholder="FULL NAME"
          />
          <input
            type="email"
            className="w-full h-12 bg-[#979797]/20 px-4 outline-none placeholder:text-secondary"
            name="email"
            placeholder="E-MAIL"
          />
          <input
            type="number"
            className="w-full h-12 bg-[#979797]/20 px-4 outline-none placeholder:text-secondary"
            name="email"
            placeholder="MOBILE"
          />
          <textarea
            name="message"
            id=""
            cols="30"
            rows="10"
            className="w-full bg-[#979797]/20 p-4 outline-none placeholder:text-secondary"
            placeholder="YOUR MESSAGE"
          />
          <button className="h-12 w-full bg-secondary text-white">
            SEND MESSAGE
          </button>
        </form>
      </div>
      <div className="flex flex-col items-center space-y-20">
        <div className="text-center w-3/5 md:w-full">
          <h1 className="mb-3 text-4xl md:text-2xl">
            GET IN <span className="h1-span text-secondary">TOUCH</span> WITH
            US!
          </h1>
          <p className="text-secondary font-semibold">
            We would love to hear from you. Talk to us today.
          </p>
        </div>
        <ChatWithUs />
      </div>
    </div>
  );
};

export default Donate;
